import { Component } from 'solid-js'
import { CharEditor } from '../editor'
import Tooltip from '/web/shared/Tooltip'
import { WandSparkles } from 'lucide-solid'
import Button from '/web/shared/Button'
import { toastStore, i18nStore } from '/web/store'

export const Regenerate: Component<{
  field: string
  trait?: string
  editor: CharEditor
  class?: string
}> = (props) => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  return (
    <Tooltip
      tip={i18n.t.char_regenerate_tooltip}
      position="right"
      disable={props.editor.canGenerate()}
    >
      <Button
        size="sm"
        class={`inline-block ${props.class || ''}`}
        onClick={() => {
          if (!props.editor.canGenerate()) {
            toastStore.warn(i18n.t.char_regenerate_warn)
            return
          }
          props.editor.generateField(props.field, props.trait)
        }}
        disabled={props.editor.generating()}
      >
        <WandSparkles size={16} />
      </Button>
    </Tooltip>
  )
}
